/**
 * @fileoverview gRPC-Web generated client stub for admpb
 * @enhanceable
 * @public
 */

// GENERATED CODE -- DO NOT EDIT!


/* eslint-disable */
// @ts-nocheck



const grpc = {};
grpc.web = require('grpc-web');

const proto = {};
proto.admpb = require('./faq_pb.js');

/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?Object} options
 * @constructor
 * @struct
 * @final
 */
proto.admpb.FAQServiceClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options['format'] = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname;

};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?Object} options
 * @constructor
 * @struct
 * @final
 */
proto.admpb.FAQServicePromiseClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options['format'] = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname;

};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.admpb.FAQ,
 *   !proto.admpb.ListFAQResponse>}
 */
const methodDescriptor_FAQService_ListFAQ = new grpc.web.MethodDescriptor(
  '/admpb.FAQService/ListFAQ',
  grpc.web.MethodType.UNARY,
  proto.admpb.FAQ,
  proto.admpb.ListFAQResponse,
  /**
   * @param {!proto.admpb.FAQ} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.admpb.ListFAQResponse.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.admpb.FAQ,
 *   !proto.admpb.ListFAQResponse>}
 */
const methodInfo_FAQService_ListFAQ = new grpc.web.AbstractClientBase.MethodInfo(
  proto.admpb.ListFAQResponse,
  /**
   * @param {!proto.admpb.FAQ} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.admpb.ListFAQResponse.deserializeBinary
);


/**
 * @param {!proto.admpb.FAQ} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.admpb.ListFAQResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.admpb.ListFAQResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.admpb.FAQServiceClient.prototype.listFAQ =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/admpb.FAQService/ListFAQ',
      request,
      metadata || {},
      methodDescriptor_FAQService_ListFAQ,
      callback);
};


/**
 * @param {!proto.admpb.FAQ} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.admpb.ListFAQResponse>}
 *     A native promise that resolves to the response
 */
proto.admpb.FAQServicePromiseClient.prototype.listFAQ =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/admpb.FAQService/ListFAQ',
      request,
      metadata || {},
      methodDescriptor_FAQService_ListFAQ);
};


module.exports = proto.admpb;

